import { render, staticRenderFns } from "./WorksInfo.vue?vue&type=template&id=2fb51e4a&scoped=true&"
import script from "./WorksInfo.vue?vue&type=script&lang=js&"
export * from "./WorksInfo.vue?vue&type=script&lang=js&"
import style0 from "./WorksInfo.vue?vue&type=style&index=0&id=2fb51e4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb51e4a",
  null
  
)

export default component.exports